import React from "react";
import MainComponent from "../../Components/LandingPage/MainComponent";
import Header from "../../Components/Common/Header";

function Home() {
  return (
    <div>
      <Header></Header>
      <MainComponent></MainComponent>
    </div>
  );
}

export default Home;
